import React from 'react';

const BrandIcon = ({ size = 24, className = "", gradientClass = "from-[#4f46e5] to-[#ec4899]" }) => {
    return (
        <div className={`flex items-center justify-center rounded-xl bg-gradient-to-br ${gradientClass} shadow-md shadow-indigo-500/20 ${className}`} style={{ width: size * 1.5, height: size * 1.5 }}>
            <span className="text-white font-black italic tracking-tighter" style={{ fontSize: size * 0.9 }}>N</span>
        </div>
    );
};

export default BrandIcon;
